//import axios from 'axios';
//const API_URL = 'http://localhost:8081/api/auth/';

import {http} from "@/plugins/axios"

class AuthService {
  login(user) {
    return http
      .post('/auth/signin', {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  /* register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  } */
}

export default new AuthService();
